import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import Vue from 'vue';

const TrackingListsRepository = RepositoryFactory.get('trackingLists');

const state = {
    trackinglist: {},
    filteredSpaces: [],
    activeInteractionSpace: null, //last spaceID of which the interaction dialog has opened
};

// getters
const getters = {
    trackingList: (state) => {
        if (Object.keys(state.trackinglist).length !== 0) {
            return state.trackinglist;
        }
        return null;
    },
    filteredSpaces: (state) => {
        return state.filteredSpaces;
    }
};

// actions
const actions = {
    async fetch({commit}, id) {
        try {
            const {data} = await TrackingListsRepository.getTrackingList(id);
            if (Object.keys(data).length !== 0 && data.constructor === Object) {
                commit('setTrackinglist', data);
            }
        } catch (e) {
            Vue.noty.error(e.message);
            console.error(e);
        }
    },
    async editTrackingList({state}) {
        try {
            const json = {
                id: state.trackinglist.id,
                name: state.trackinglist.name,
                target_medium: state.trackinglist.target_medium,
                spaceIds: state.filteredSpaces.map(space => space.id)
            };
            await TrackingListsRepository.updateTrackingList(state.trackinglist.id, json);
            Vue.noty.success("Die Trackingliste wurde erfolgreich gespeichert!");
        } catch (e) {
            Vue.noty.error("Fehler bei der Aktualisierung der Trackinglist Vorlage: " + e.message);
            console.error(e);
        }
    },
};

function arrayMove(array, from, to) {
    array.splice(to, 0, array.splice(from, 1)[0]);
}

function isInteractionValid(inter, deviceType) {
    let valid = false;
    switch (deviceType.toLowerCase()) {
        case "online":
            if (inter.on_desktop === 1 || inter.on_tablet === 1) {
                valid = true;
            }
            break;
        case "desktop":
            if (inter.on_desktop === 1) {
                valid = true;
            }
            break;
        case "mobile":
            if (inter.on_mobile === 1) {
                valid = true;
            }
            break;
        case "tablet":
            if (inter.on_tablet === 1) {
                valid = true;
            }
            break;
    }
    return valid;
}

function filterSpacesByType(state, deviceType) {
    state.filteredSpaces.length = 0;
    for (let i = 0; i < state.trackinglist.spaces.length; i++) {
        let space = state.trackinglist.spaces[i];
        state.filteredSpaces.push(space);
        let filteredInteractions = [];
        for (let j = 0; j < state.trackinglist.spaces[i].interactions.length; j++) {
            let inter = state.trackinglist.spaces[i].interactions[j];
            if (isInteractionValid(inter, deviceType)) {
                filteredInteractions.push(inter);
            }
        }
        for (let j = 0; j < state.trackinglist.spaces[i].modules.length; j++) {
            let module = state.trackinglist.spaces[i].modules[j];
            let filteredModuleInteractions = [];
            for (let k = 0; k < module.interactions.length; k++) {
                let inter = module.interactions[k];
                if (isInteractionValid(inter, deviceType)) {
                    filteredModuleInteractions.push(inter);
                }
            }
            module.filteredInteractions = filteredModuleInteractions;
        }
        filteredInteractions.sort(sort);
        space.filteredInteractions = filteredInteractions;
    }
}

function sort(x, y) {
    console.log(x);
    if (x.pivot.sort < y.pivot.sort) {
        return -1;
    }
    if (x.pivot.sort > y.pivot.sort) {
        return 1;
    }
    return 0;
}

// mutations
const mutations = {
    moveSpaceUp(state, index) {
        if (index > 0) {
            arrayMove(state.filteredSpaces, index, index - 1);
        }
    },
    moveSpaceDown(state, index) {
        if (index < state.filteredSpaces.length - 1) {
            arrayMove(state.filteredSpaces, index, index + 1);
        }
    },
    filterSpaces(state, deviceType) {
        filterSpacesByType(state, deviceType);
    },
    sortSpaces(state) {
        let copy = JSON.parse(JSON.stringify(state.trackinglist.spaces));
        copy.sort(sort);
        copy.forEach(space => {
            space.interactions.sort(sort);
            space.modules.sort(sort);
            space.modules.forEach(mod => {
                mod.interactions.sort(sort);
            })
        });
        state.trackinglist.spaces = copy;
        copy = JSON.parse(JSON.stringify(state.filteredSpaces));
        copy.sort(sort);
        copy.forEach(space => {
            space.interactions.sort(sort);
            space.modules.sort(sort);
            space.modules.forEach(mod => {
                mod.interactions.sort(sort);
                mod.filteredInteractions.sort(sort);
            })
        });
        state.filteredSpaces = copy;
    },
    setTrackinglist(state, data) {
        state.trackinglist = data;
        state.trackinglist.spaces.forEach((space) => {
            space.interactions.forEach((interaction) => {
                interaction.original = true;
            });
            state.filteredSpaces.push(space);
        });
        filterSpacesByType(state, state.trackinglist.target_medium);
    },
    setSpaces(state, spaces) {
        state.trackinglist.spaces = state.trackinglist.spaces.concat(spaces);
        state.trackinglist.spaces.forEach(space => {
            space.hide = false;
        });
        state.filteredSpaces = JSON.parse(JSON.stringify(state.trackinglist.spaces));
        filterSpacesByType(state, state.trackinglist.target_medium);
    },
    setName(state, name) {
        state.trackinglist.name = name;
    },
    setTargetMedium(state, target_medium) {
        state.trackinglist.target_medium = target_medium;
    },
    setActiveInteractionSpace(state, spaceID) {
        state.activeInteractionSpace = spaceID;
    },
    deleteSpace(state, space) {
        state.filteredSpaces.splice(state.filteredSpaces.indexOf(space), 1);
        for (let i = 0; i < state.trackinglist.spaces.length; i++) {
            if (state.trackinglist.spaces[i].id === space.id) {
                state.trackinglist.spaces.splice(i, 1);
                break;
            }
        }
        filterSpacesByType(state, state.trackinglist.target_medium);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}